"use client";

import React from "react";
import { Typography } from "@/components/ui/typography";
import IndustryCardsCarousel, { IndustryCard } from "./IndustryCardsCarousel";

export type IndustryContent = {
  heading: string;
  subheading: string;
  cards: IndustryCard[];
};

type Props = {
  content: IndustryContent;
};

export default function IndustryBlock({ content }: Props) {
  return (
    <section className="section overflow-hidden border-b border-b-neutral-200 md:border-b-0">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8">
          <Typography variant="heading4">
            <h2>{content.heading}</h2>
          </Typography>
          <Typography variant="subHeadingSm" className="text-gray-600" asChild>
            <p>{content.subheading}</p>
          </Typography>
        </div>
        <IndustryCardsCarousel
          cards={content?.cards}
          className="mt-6 lg:!mt-12"
        />
      </div>
    </section>
  );
}
